import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-master-list',
  templateUrl: './master-list.component.html',
  styleUrls: ['./master-list.component.scss']
})
export class MasterListComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[]; 
  public currentUrl:any=this.router.url;

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail();
   }

  ngOnInit(): void {
  }

  getDetail(){  
    this.loading = true;
    var url:any='/demographic';   
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          this.dataListing= response.data;  
          this.loading=false;
        } else {
          this.dataListing=[];  
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }

}
